<app-async-block [inRequest]="(performanceFacade.sectorInRequest$ | async) === true">
  <app-performance-win-table
    [columns]="SECTOR_COLUMNS"
    [order]="(performanceFacade.sectorOrder$ | async) || DEFAULT_SECTOR_ORDER"
    [sortBy]="(performanceFacade.sectorSortBy$ | async) || DEFAULT_SECTOR_SORT_BY"
    [performanceRates]="(data$ | async) || []"
    [performanceRatesTotal]="total$ | async"
    (changeSort)="changeSort($event.sortBy, $event.order)"
  >
    <ng-container title>{{ 'performance.winRatesBySector.title' | translate }}</ng-container>
    <ng-container subtitle>
      <p>{{ 'performance.winRatesBySector.subTitle' | translate }}</p>
      <ul>
        <li>{{ 'performance.winRatesBySector.description.win' | translate }}</li>
        <li>{{ 'performance.winRatesBySector.description.error' | translate }}</li>
      </ul>
    </ng-container>
  </app-performance-win-table>
</app-async-block>
